import React from 'react'
import Input from '../../form/Input'

class Step1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      budget: this.props.data.budget
    };
  }

  submit = () => {
    if (!this.state.budget) {
      this.setState({ errors: 'this field is required'})
    } else {
      this.props.submit(this.state);
    }
  };

  render() {
    return (
      <React.Fragment>
        <p className="title mb-10">What is your total budget?</p>

        <p className="mb-30 text-tuna">Lussy.io will crawl your website to find relevant information like social profiles.</p>

        <div className="mx-auto" style={{ maxWidth: '370px' }}>
          <div className="mb-30">
            <Input
              type='number'
              label="Budget (USD)"
              value={this.state.budget}
              onChange={(budget) => this.setState({budget, errors: ''})}
            />
          </div>

          {this.state.errors && <p className="mb2 text-violet-red">{this.state.errors}</p>}

          <a
            className="btn btn--primary col-12 mb-10"
            onClick={this.submit}
          >
            Next
          </a>
        </div>
      </React.Fragment>
    );
  }
}

export default Step1
